import {
  PLAN_BASE_FEATURES_EXCLUDED,
  PLAN_BASE_FEATURES_INCLUDED,
  PLAN_PRO_DIFF_FEATURES,
  PLAN_PRO_EXTRA_FEATURES,
} from '@constants/pricingPlans'

export function PlanFeatureList({ variant, dark }: { variant: 'base' | 'pro'; dark?: boolean }) {
  const ok = dark ? 'text-primary-400' : 'text-primary-600'
  const text = dark ? 'text-white/80' : 'text-secondary-700'
  const muted = dark ? 'text-white/35' : 'text-secondary-400'
  const ai = dark ? 'text-primary-300' : 'text-primary-700'
  const aiMark = dark ? 'text-primary-300' : 'text-primary-700'
  const diffBox = dark
    ? 'border-primary-400/30 bg-primary-500/10'
    : 'border-primary-200 bg-primary-50'
  const diffLabel = dark ? 'text-primary-300' : 'text-primary-600'

  if (variant === 'base') {
    return (
      <ul className={`mb-6 flex flex-col gap-2.5 text-sm leading-snug ${text}`}>
        {PLAN_BASE_FEATURES_INCLUDED.map((feat) => (
          <li key={feat} className="flex gap-2">
            <span className={`shrink-0 pt-0.5 ${ok}`}>✓</span>
            <span>{feat}</span>
          </li>
        ))}
        {PLAN_BASE_FEATURES_EXCLUDED.map((feat) => (
          <li key={feat} className={`flex gap-2 ${muted} line-through`}>
            <span className="shrink-0 pt-0.5">✕</span>
            <span>{feat}</span>
          </li>
        ))}
      </ul>
    )
  }

  return (
    <>
      <div className={`mb-4 rounded-xl border p-4 ${diffBox}`}>
        <p className={`mb-2.5 text-xs font-bold uppercase tracking-wider ${diffLabel}`}>✦ O que o Pro faz a mais</p>
        <ul className={`flex flex-col gap-2.5 text-sm leading-snug ${text}`}>
          {PLAN_PRO_DIFF_FEATURES.map((feat) => (
            <li key={feat} className="flex gap-2">
              <span className={`shrink-0 pt-0.5 font-bold ${aiMark}`}>✦</span>
              <span className={`font-medium ${ai}`}>{feat}</span>
            </li>
          ))}
        </ul>
      </div>
      <ul className={`mb-6 flex flex-col gap-2.5 text-sm leading-snug ${text}`}>
        {PLAN_PRO_EXTRA_FEATURES.map((feat) => (
          <li key={feat} className="flex gap-2">
            <span className={`shrink-0 pt-0.5 ${ok}`}>✓</span>
            <span>{feat}</span>
          </li>
        ))}
      </ul>
    </>
  )
}
